import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function AudienceAgeChart({ data }) {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Répartition par âge
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data}>
            <XAxis dataKey="range" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </CustomCard>
  );
}
